import { TypeOf, yup } from '@guiker/yup-util'

import { tenantApplicationBackgroundCheckSchema } from '../../schemas'

export const updateTenantApplicationPayloadValidator = yup.object({
  backgroundCheck: tenantApplicationBackgroundCheckSchema.required(),
})

export type UpdateTenantApplicationPayload = TypeOf<typeof updateTenantApplicationPayloadValidator>
